import { Director as _Director } from 'components/NetworkRegister/NetworkRegisterInterface/NetworkRegisterInterface';

export const actionTypes = {
  SET_CLUB_DETAILS: 'CLUBS/SET_CLUB_DETAILS',
  SET_DIRECTORS: 'CLUBS/SET_DIRECTORS',
  CLEAR_DATA: 'CLUBS/CLEAR_DATA',
};

export type Director = _Director;

export type ClubViewModel = {
  id: string;
  name: string;
  email: string;
  address: string;
  isActive: boolean;
};

export enum AVAILABLE_STATUSES {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum AVAILABLE_ACTIVATIONS {
  ACTIVATE = 'Activate',
  DEACTIVATE = 'Deactivate',
}

export type ClubState = {
  clubDetails: ClubRegisterData;
  directors: Director[];
};

export type ClubRegisterData = {
  clubName: string;
  postcode: string;
  houseNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county?: string;
  email: string;
  telephoneNumber: string;
  commissionTerms: string;
  sortCode: string;
  accNumber: number | '';
  accName: string;
};

export type DirectorRequestData = any;

export type ClubRegisterRequestData = {
  name: string;
  post_code: string;
  house_number: string;
  street_line_1?: string;
  street_line_2?: string;
  city: string;
  county?: string;
  email: string;
  phone_number: string;
  commission_term_id: string;
  account_sort_code: string;
  account_number: number | '';
  account_name: string;
  directors: DirectorRequestData[];
};
